import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import ReactGA from 'react-ga4';

import { ChakraProvider } from '@chakra-ui/react';
import { CoffeeShopProvider } from "./context/CoffeeShopContext";
import theme from './styles/theme';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // To prevent re-render
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <CoffeeShopProvider>
        <App />
      </CoffeeShopProvider>
      </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
